import api from "../axios_service.js";

export async function getAudits(filtros) {
  const response = await api.get(`/admin/audits${filtros ? filtros : ""}`);
  return response.data.result;
}
